@if (loading) {
  <div>
    <h3 class="panel-title"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</h3>
  </div>
} @else {
  <div class="flex-left-column light-control-host" (keydown.escape)="onCancelClick()" tabindex="0">
    <div class="modal-header">
      <h3 class="panel-title">Sandbox Settings</h3>
      <button type="button" class="modal-close-btn" (click)="onCancelClick()">
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    <div>
      Review and modify sandbox settings for the current “{{ application ? application.name : '' }}” recovery test.
      <a href="{{ uiService.networkSandboxDocsUrl }}" target="_blank">Learn more.</a>
    </div>
    @if (accountService.networkSandboxEnabled) {
      <form [formGroup]="launchTestSettingsFormModel" class="full-width">
        <div class="flex-center-row full-width">
          <div class="spacer full-width">
            @if (advancedNetworkSandbox) {
              <hr />
              <h3 class="margin-top">Allow outbound access to these domains</h3>
              <div class="sandbox-scroll-list">
                <string-list-control
                  class="spacer"
                  [validationFunction]="isValidDomain"
                  [placeholderText]="domainAllowlistPlaceholderText"
                  (validated)="sandboxDomainsValidated($event)"
                  formControlName="sandboxAllowedDomains"
                ></string-list-control>
              </div>
              <h4 class="margin-top">Suggested Domains</h4>
              @if (loadingSuggestedDomains) {
                <div>
                  <div class="no-suggestions margin-top margin-bottom">
                    <i class="fa-solid fa-spinner fa-spin"></i> Loading...
                  </div>
                </div>
              } @else {
                <div class="sandbox-scroll-list">
                  @if (suggestedDomains.length === 0) {
                    <div class="no-suggestions">No suggestions available</div>
                  }
                  @for (suggestion of suggestedDomains; track suggestion) {
                    <div class="suggestion">
                      <button class="arpio-button small-button" (click)="addAllowedDomain(suggestion.value)">
                        <i class="fa-solid fa-plus"></i>
                      </button>
                      {{ suggestion.value }} <span class="suggestion-reason">({{ suggestion.reason }})</span>
                    </div>
                  }
                </div>
              }
            }
            <hr />
            <h3 class="margin-top">Allow outbound access to these CIDR blocks</h3>
            <div class="sandbox-scroll-list">
              <string-list-control
                class="spacer"
                [validationFunction]="isValidCidr"
                [normalizeFunction]="normalizeCidr"
                [placeholderText]="whitelistPlaceholderText"
                (validated)="whitelistValidated($event)"
                formControlName="sandboxWhitelist"
              ></string-list-control>
            </div>
            @if (advancedNetworkSandbox) {
              <h4 class="margin-top">Suggested CIDRs</h4>
              @if (loadingSuggestedCidrs) {
                <div>
                  <div class="no-suggestions margin-top margin-bottom">
                    <i class="fa-solid fa-spinner fa-spin"></i> Loading...
                  </div>
                </div>
              } @else {
                <div class="sandbox-scroll-list">
                  @if (suggestedCidrs.length === 0) {
                    <div class="no-suggestions">No suggestions available</div>
                  }
                  @for (suggestion of suggestedCidrs; track suggestion) {
                    <div class="suggestion">
                      <button class="arpio-button small-button" (click)="addAllowedCidr(suggestion.value)">
                        <i class="fa-solid fa-plus"></i>
                      </button>
                      {{ suggestion.value }} <span class="suggestion-reason">({{ suggestion.reason }})</span>
                    </div>
                  }
                </div>
              }
            }
            @if (!advancedNetworkSandbox) {
              <div class="sandbox-checkbox half-margin-top">
                <label for="sandbox-allow-s3">
                  <input
                    id="sandbox-allow-s3"
                    class="arpio-checkbox"
                    type="checkbox"
                    formControlName="allowS3Checked"
                  />
                  Allow outbound access to S3 IPs
                </label>
              </div>
              <div class="sandbox-checkbox half-margin-top">
                <label>
                  <input
                    id="sandbox-allow-dynamo"
                    class="arpio-checkbox"
                    type="checkbox"
                    formControlName="allowDynamoChecked"
                  />
                  Allow outbound access to DynamoDB IPs
                </label>
              </div>
            }
          </div>
        </div>
      </form>
    }
    <hr />
    @if (otherApplicationNames.length > 0) {
      <div class="notice-info margin-top">
        <i class="fa-solid fa-circle-info"></i>
        <div>
          <div class="notice-title">These changes will also apply to the following applications:</div>
          <truncated-list [items]="otherApplicationNames" maxVisible="10"></truncated-list>
        </div>
      </div>
    }
    @if (currentlySyncingMessage) {
      <div class="error margin-top flex-center-row full-width">
        <p class="full-width">
          Arpio is applying your latest recovery point. Once it's done applying, you will be able to update your sandbox
          settings.
        </p>
      </div>
      <div class="error flex-center-row full-width">
        <div class="spacer"></div>
        <h1><i class="fa-solid fa-spinner fa-spin"></i></h1>
        <div class="spacer"></div>
      </div>
    }
    <div class="modal-footer">
      <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
      <button
        busy-button
        [busy]="launching"
        id="failover-button"
        class="arpio-button"
        (click)="onUpdateClick()"
        [disabled]="!canUpdate"
      >
        UPDATE
      </button>
    </div>
  </div>
}
